import { EEIIIP_TABLE_COLUMNS } from '../constants'

export const eeiiIpDataPreparation = (data, { intl }) => {
  return data.map((item) => {
    const formattedColumns = {}
    EEIIIP_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedColumns[column.field] = intl.formatDate(item[column.field])
      }
      if (column.infoType === 'logic') {
        formattedColumns[column.field] = item[column.field] ? 'Sí' : 'No'
      }
      if (column.infoType === 'toRound') {
        formattedColumns[column.field] = item[column.field] ? item[column.field].toFixed(2) : '--'
      }
      if (column.field === 'gremio_ip_id') {
        formattedColumns[column.field] = item.gremio_ip ? item.gremio_ip.id : '--'
      }
    })
    return {
      ...item,
      ...formattedColumns,
      tableData: {
        ...item.tableData,
      },
    }
  })
}
